var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerifiedIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    color: "#AFAFBB",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.52727 15.6668L4.14545 13.3303L1.52727 12.7462L1.78182 10.0446L0 8.00016L1.78182 5.95572L1.52727 3.25413L4.14545 2.67L5.52727 0.333496L8 1.39223L10.4727 0.333496L11.8545 2.67L14.4727 3.25413L14.2182 5.95572L16 8.00016L14.2182 10.0446L14.4727 12.7462L11.8545 13.3303L10.4727 15.6668L8 14.6081L5.52727 15.6668ZM7.23636 10.5922L11.3455 6.46683L10.3273 5.4081L7.23636 8.51127L5.67273 6.97794L4.65455 8.00016L7.23636 10.5922Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedIc);
export default __webpack_public_path__ + "static/media/verified_ic.f5fa0bc099f483b558327f6b80fe86ba.svg";
export { ForwardRef as ReactComponent };